import { saveAs } from 'file-saver/FileSaver';
import { Observable, Subject } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { FileSystemHelper } from '../../../app/helpers/file-system.helper';
import { FileHelper, PathInfoType } from '../../../app/helpers/file-system/file.helper';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import { File } from './file.model';

export class FileDesktopFacade {

    constructor(protected appFacade: VasAppFacade) {

    }

    saveBlobAs(blob: Blob, fileName: string): void {
        saveAs(blob, fileName);
    }

    fileExists(file: File): Observable<boolean> {

        if (!file.localFileSystemPath) {
            return of(false);
        }
        const subject = new Subject<boolean>();
        const img = document.createElement('img');
        img.src = file.localFileSystemPath;
        img.onload = () => {
            subject.next(true);
            subject.complete();
        };
        img.onabort = () => {
            subject.next(false);
            subject.complete();
        };
        img.onerror = () => {
            subject.next(false);
            subject.complete();
        };
        return subject;
    }

    /**
     * This method accepts a blob and displays it in an empty browser tab
     *
     * NOTE: this method should not be used on the mobile app as it will crash
     *
     * @param blob {Blob}
     * @return {Promise<any>}
     */
    async blobToPreviewPage(blob: Blob): Promise<any> {

        if (!this.appFacade.platform.is('core')) {
            return Promise.reject(Error('method not supported on mobile'));
        }

        const newWindow = window.open('/assets/preview.html', '_blank');

        if (!newWindow) {
            return Promise.reject(
                Error(
                    'Your browser has prevented opening the new window. Update your settings and try again'
                )
            );
        }

        return new Promise((resolve, reject) => {
            newWindow.onload = () => {
                (newWindow as any).location = URL.createObjectURL(blob);
                resolve();
            };
            newWindow.onerror = error => {
                reject(error);
            };
        });
    }

    async fileToDataUrl(file: File): Promise<string> {

        if (!file.localFileSystemPath) {
            return Promise.reject(Error('undefined localFileSystemPath'));
        }

        const path = file.localFileSystemPath;
        const pathInfo = FileHelper.parsePath(path);

        if (pathInfo.type === PathInfoType.FILESYSTEM) {
            return this.appFacade.filesystem.pathToObjectUrl(path);
        }
        return Promise.resolve(path);
    }

    async fileToBlob(file: File): Promise<Blob> {

        if (!file.localFileSystemPath) {
            return Promise.reject(Error('undefined localFileSystemPath'));
        }

        return FileSystemHelper.objectUrlToBlob(file.localFileSystemPath);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file-desktop.facade.ts